<template>
  <div class="sidebar" :class="{ active: sidebarActive }">
    <button class="sidebar__close" @click="toggleSidebar">
      <img src="@/assets/close.svg" alt="" />
    </button>
    <filters :lazy="true" :counter="false" :clear="true"></filters>
    <!-- <a href="" class="sidebar__more">
      Wczytaj więcej filtrów
      <span>
        <img src="@/assets/plus.png" alt="plus" />
      </span>
    </a> -->
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';

// Components
import filters from '@/layout/filters.vue';

export default {
  name: 'sidebar',
  components: {
    filters,
  },
  methods: {
    ...mapMutations({
      toggleSidebar: 'TOGGLE_SIDEBAR',
    }),
  },
  computed: {
    ...mapState({ sidebarActive: state => state.browser.sidebarActive }),
  },
};
</script>

<style lang="scss" scoped>
.sidebar {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: $sidebarWidth;
  height: 100%;
  flex-basis: $sidebarWidth;
  overflow-x: hidden;

  padding: 2%;

  box-shadow: -10px 0 15px rgba(#000, 0.07);

  background: rgba(255, 255, 255, 0.8);
  backdrop-filter: blur(8px);
  position: fixed;
  top: 0;
  right: 0;
  transform: translateX(($sidebarWidth + 50px));
  z-index: 35;

  transition: 250ms;
  @media screen and (max-width: $xs) {
    max-width: 100%;
    width: 100%;
    height: 100%;
    transform: translateX(calc(100% + 50px));
    padding: {
      bottom: 40px;
      left: 8%;
      right: 8%;
    }
    //overflow: hidden;
    justify-content: space-around;
  }
  @media screen and (max-height: 575px) {
    display: none;
  }
  &.active {
    transform: translateX(0);
  }
}

.sidebar__close {
  position: absolute;
  right: 5%;
  top: 100px;

  display: flex;
  justify-content: center;
  align-items: center;

  width: 40px;
  height: 40px;

  background: none;
  border: 1px solid #000;

  border-radius: 50%;

  cursor: pointer;

  img {
    display: block;
  }
}

.sidebar--floor {
  position: absolute;
  z-index: 10;
  left: 0;
  top: 50%;
  transform: translateY(-50%);

  @media screen and (max-width: $sm) {
    top: auto;
    bottom: 0;
    transform: translateX(-50%);
    left: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 80%;
  }

  .sidebar__nav {
    display: flex;
    flex-direction: column-reverse;
    @media screen and (max-width: $sm) {
      flex-direction: row;
      flex-wrap: wrap;
    }
  }
  .sidebar__link {
    @media screen and (max-width: $sm) {
      padding: 4px 10px;
    }
  }
  .sidebar__text {
    text-align: center;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 6px;
    @media screen and (max-width: $sm) {
      margin: {
        bottom: 0;
      }
    }
  }
}

.sidebar__link {
  color: #000;
  padding: 0.5rem 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 22px;
  text-decoration: none;
  position: relative;
  &.active {
    color: red;
    font-weight: 600;

    &:before {
      content: '';
      display: block;
      width: 26px;
      height: 1px;
      background: rgba(#000, 0.9);
      position: absolute;
      left: 0;

      @media screen and (max-width: $sm) {
        height: 12px;
        width: 1px;
        left: auto;
        bottom: 90%;
      }
    }
  }
}

.sidebar__show {
  position: absolute;
  right: 0;
  top: 150px;

  padding: 14px 12px;

  cursor: pointer;

  border: none;
  background: #000;
  color: #fff;
  @media screen and (max-width: $sm) {
    top: 30px;
    padding: 10px 8px;
    font-size: 12px;
  }
  @media screen and (max-height: 575px) {
    display: none;
  }
}

.sidebar__more {
  display: flex;
  align-items: center;
  margin-left: auto;
  margin-top: 12px;

  font-size: 14px;
  text-decoration: none;
  color: inherit;
  span {
    display: flex;
    justify-content: center;
    align-items: center;

    width: 40px;
    height: 40px;

    margin-left: 10px;

    border-radius: 50%;
    background: $primaryColor;
    img {
      display: block;
      height: 10px;
      width: 10px;
    }
  }
}
</style>
